/* RH cart helper (Sept 2026)
   Shows the Rs 400 minimum order and the Rs 1,000 free-shampoo level inside the cart,
   suggests small add-ons, and stops checkout below the minimum so nobody reaches a
   checkout that has no delivery option. Amounts are in paise. */
(function () {
  if (window.__rhCartNudge) return;
  window.__rhCartNudge = true;

  var MIN = 40000, NEAR = 85000, GIFT = 100000;
  var FALLBACK = '/collections/customer-favourites/products.json?limit=12';
  var lastSig = '', timer = null, observer = null, running = false, pending = false;

  function money(p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); }

  function injectCss() {
    if (document.getElementById('rh-nudge-css')) return;
    var s = document.createElement('style');
    s.id = 'rh-nudge-css';
    s.textContent =
      '.rh-nudge{background:#F8F6EB;border:1px solid #E7E3D8;border-radius:8px;padding:12px 14px;margin:0 0 12px;font-size:14px;line-height:1.45;color:#1E3A2C}' +
      '.rh-nudge__msg{font-weight:700;margin:0 0 8px}' +
      '.rh-nudge__msg.is-warn{color:#9a4a10}.rh-nudge__msg.is-win{color:#1b5e20}' +
      '.rh-nudge__track{height:8px;border-radius:8px;background:#e6e2d4;position:relative}' +
      '.rh-nudge__fill{height:100%;border-radius:8px;background:linear-gradient(90deg,#314a3c,#5c7a34);transition:width .45s ease}' +
      '.rh-nudge__mark{position:absolute;top:-4px;width:2px;height:16px;background:#8a8572;left:40%}' +
      '.rh-nudge__labels{position:relative;height:30px;font-size:11px;color:#5d675f;margin-top:6px}' +
      '.rh-nudge__labels span{position:absolute;transform:translateX(-50%);text-align:center;white-space:nowrap;line-height:1.3}' +
      '.rh-nudge__sugs{margin-top:10px;border-top:1px solid #E7E3D8;padding-top:8px}' +
      '.rh-nudge__sugs h4{margin:0 0 6px;font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#5d675f}' +
      '.rh-nudge__sug{display:flex;justify-content:space-between;align-items:center;gap:10px;padding:4px 0;font-size:13px}' +
      '.rh-nudge__sug a{color:#1E3A2C;text-decoration:none}' +
      '.rh-nudge__sug button{flex:none;border:1px solid #1E3A2C;background:#fff;color:#1E3A2C;font-weight:700;border-radius:4px;padding:5px 12px;font-size:13px;cursor:pointer}' +
      '.rh-nudge__sug button[disabled]{opacity:.5;cursor:wait}' +
      '.rh-nudge__cod{font-size:12px;color:#5d675f;margin:8px 0 0;text-align:center}' +
      '.rh-nudge--pulse{animation:rhNudgePulse 1.1s ease 3}' +
      '@keyframes rhNudgePulse{50%{background:#fff0d9}}';
    document.head.appendChild(s);
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function pick(list, inCart, gap) {
    return list
      .filter(function (p) { return p.variantId && p.price > 0 && !inCart[p.productId] && p.price <= Math.max(gap + 15000, 25000); })
      .sort(function (a, b) { return Math.abs(a.price - gap) - Math.abs(b.price - gap); })
      .slice(0, 3);
  }

  function fromRecommendations(json) {
    return ((json && json.products) || []).map(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.available; })[0];
      return { productId: p.id, title: p.title, url: p.url, price: v ? v.price : 0, variantId: v ? v.id : null };
    });
  }

  function fromCollection(json) {
    return ((json && json.products) || []).map(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.available; })[0];
      return { productId: p.id, title: p.title, url: '/products/' + p.handle, price: v ? Math.round(parseFloat(v.price) * 100) : 0, variantId: v ? v.id : null };
    });
  }

  function suggestions(cart, gap) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var first = cart.items[0];
    var rec = first ? getJSON('/recommendations/products.json?product_id=' + first.product_id + '&limit=8&intent=related') : Promise.resolve(null);
    return rec.then(function (json) {
      var picks = pick(fromRecommendations(json), inCart, gap);
      if (picks.length >= 3) return picks;
      return getJSON(FALLBACK).then(function (cj) {
        var seen = {};
        picks.forEach(function (p) { seen[p.productId] = true; });
        var more = pick(fromCollection(cj), inCart, gap).filter(function (p) { return !seen[p.productId]; });
        return picks.concat(more).slice(0, 3);
      });
    });
  }

  function shortTitle(t) {
    t = String(t || '').split(' | ')[0].split(' – ')[0];
    return t.length > 46 ? t.slice(0, 44) + '…' : t;
  }

  function build(total, sugs, target) {
    var box = document.createElement('div');
    box.className = 'rh-nudge';
    box.setAttribute('data-rh-nudge', '');

    var msg = document.createElement('p');
    msg.className = 'rh-nudge__msg';
    if (total < MIN) { msg.className += ' is-warn'; msg.textContent = 'Add ' + money(MIN - total) + ' more to place your order (minimum order ₹400).'; }
    else if (total < NEAR) { msg.textContent = 'Order unlocked. Prepaid delivery is free.'; }
    else if (total < GIFT) { msg.className += ' is-warn'; msg.textContent = 'Add just ' + money(GIFT - total) + ' more and get Kesh Nirogi Shampoo (worth ₹130) FREE.'; box.className += ' rh-nudge--pulse'; }
    else { msg.className += ' is-win'; msg.textContent = 'You have unlocked a FREE Kesh Nirogi Shampoo (worth ₹130). We pack it with this order and you pay nothing for it.'; }
    box.appendChild(msg);

    var track = document.createElement('div');
    track.className = 'rh-nudge__track';
    track.innerHTML = '<div class="rh-nudge__fill" style="width:' + Math.min(100, total / GIFT * 100) + '%"></div><div class="rh-nudge__mark"></div>';
    box.appendChild(track);

    var labels = document.createElement('div');
    labels.className = 'rh-nudge__labels';
    labels.innerHTML = '<span style="left:40%">₹400<br>Order unlocked</span><span style="left:86%">₹1,000<br>Free shampoo</span>';
    box.appendChild(labels);

    if (sugs && sugs.length) {
      var wrap = document.createElement('div');
      wrap.className = 'rh-nudge__sugs';
      var h = document.createElement('h4');
      h.textContent = target === MIN ? 'Customers also add' : 'Reach ₹1,000 with';
      wrap.appendChild(h);
      sugs.forEach(function (p) {
        var row = document.createElement('div');
        row.className = 'rh-nudge__sug';
        var a = document.createElement('a');
        a.href = p.url;
        a.textContent = shortTitle(p.title) + ' · ' + money(p.price);
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = 'Add';
        b.addEventListener('click', function () { addToCart(p.variantId, b); });
        row.appendChild(a); row.appendChild(b);
        wrap.appendChild(row);
      });
      box.appendChild(wrap);
    }

    var cod = document.createElement('p');
    cod.className = 'rh-nudge__cod';
    cod.textContent = 'Prepaid: free delivery · Cash on delivery: ₹100 extra';
    box.appendChild(cod);
    return box;
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (drawer) body.sections = 'cart-drawer,cart-icon-bubble';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (drawer && res && res.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: variantId, sections: res.sections });
        } else {
          window.location.reload();
        }
      })
      .catch(function () { btn.disabled = false; });
  }

  function lockCheckout(total) {
    var below = total > 0 && total < MIN;
    var buttons = document.querySelectorAll('#CartDrawer-Checkout, #checkout, button[name="checkout"]');
    Array.prototype.forEach.call(buttons, function (b) {
      if (!b.hasAttribute('data-rh-label')) b.setAttribute('data-rh-label', b.textContent.trim());
      if (below) {
        var label = 'Add ' + money(MIN - total) + ' more to checkout';
        if (!b.disabled) b.disabled = true;
        if (b.textContent !== label) b.textContent = label;
        if (!b.hasAttribute('data-rh-locked')) b.setAttribute('data-rh-locked', '');
      } else if (b.hasAttribute('data-rh-locked')) {
        b.disabled = false;
        b.textContent = b.getAttribute('data-rh-label');
        b.removeAttribute('data-rh-locked');
      }
    });
    var dyn = document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons');
    Array.prototype.forEach.call(dyn, function (d) { var v = below ? 'none' : ''; if (d.style.display !== v) d.style.display = v; });
  }

  function mountPoints() {
    var points = [];
    var header = document.querySelector('cart-drawer .drawer__header');
    if (header) points.push({ el: header, where: 'afterend' });
    var footer = document.querySelector('#main-cart-footer .cart__blocks');
    if (footer) points.push({ el: footer, where: 'afterbegin' });
    return points;
  }

  function render() {
    if (running) { pending = true; return; }
    running = true;
    getJSON('/cart.js').then(function (cart) {
      if (!cart) return;
      var total = cart.total_price;
      var points = mountPoints();
      var mounted = document.querySelectorAll('[data-rh-nudge]').length;
      var sig = total + '|' + cart.item_count + '|' + points.length;
      lockCheckout(total);
      if (sig === lastSig && mounted === points.length) return;
      lastSig = sig;

      var target = total > 0 && total < MIN ? MIN : (total >= NEAR && total < GIFT ? GIFT : 0);
      var job = target ? suggestions(cart, target - total) : Promise.resolve([]);
      return job.then(function (sugs) {
        if (observer) observer.disconnect();
        Array.prototype.forEach.call(document.querySelectorAll('[data-rh-nudge]'), function (n) { n.remove(); });
        if (total > 0) {
          injectCss();
          mountPoints().forEach(function (pt) { pt.el.insertAdjacentElement(pt.where, build(total, sugs, target)); });
        }
        lockCheckout(total);
        watch();
      });
    }).catch(function () {}).then(function () {
      running = false;
      if (pending) { pending = false; schedule(); }
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(render, 350);
  }

  function watch() {
    if (!observer) observer = new MutationObserver(schedule);
    var nodes = [document.querySelector('cart-drawer'), document.querySelector('cart-items'), document.getElementById('main-cart-footer')];
    nodes.forEach(function (n) { if (n) observer.observe(n, { childList: true, subtree: true }); });
  }

  function start() { watch(); render(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('pageshow', schedule);
})();
